module.exports = __webpack_public_path__ + "media/components/common/formParts/icons/Search-7e45bd9437edd65a36b2bc0db2404f1d.svg";